<template>
    <div>
        <div class="place"></div>
        <div class="operate-bar">
            <div class="comment-box"
                 @click="openDownModal">
                <span></span>
                写评论我光荣！
            </div>
            <div class="right">
                <div class="item"
                     @click="openDownModal">
                    <div class="num">{{data.comments==0?'':data.comments}}</div>
                    <span class="iconfont icon-message"></span>
                </div>
                <div class="item"
                     @click="openDownModal">
                    <div class="num">{{is_love==0?'':is_love}}</div>
                    <span class="iconfont icon-thumb"></span>
                </div>
                <div class="item"
                     @click="openDownModal">
                    <span class="iconfont icon-start"></span>
                </div>
                <div class="item"
                     @click="openDownModal">
                    <span class="iconfont icon-fenxiang"></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BottomBar",
    props: {
        detail: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            data: {},
            is_love: 0,
        };
    },
    watch: {
        detail(val) {
            this.data = val;
            this.is_love = this.data.audio.loves;
        },
    },
};
</script>

<style scoped lang="less">
.place {
    width: 100%;
    height: 40px;
}
.operate-bar {
    position: fixed;
    left: 0;
    bottom: 0;
    background: #fff;
    width: 100%;
    display: flex;
    padding: 10px 16px;
    .comment-box {
        width: 151px;
        background: #f8f8f8;
        display: flex;
        align-items: center;
        white-space: nowrap;
        color: #a7a7a7;
        font-size: 14px;
        border-radius: 6px;
        padding: 10px 12px;
        margin-right: 24px;
    }
    .right {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        .item {
            position: relative;
            .num {
                position: absolute;
                right: -5px;
                top: -5px;
                background: #ff4c67;
                padding: 0 5px;
                border-radius: 20px;
                color: #fff;
                font-size: 10px;
                transform: scale(0.8);
            }
            .iconfont {
                font-size: 24px;
            }
        }
    }
}
</style>